import { PizarraState } from './pizarra.reducers';
import * as fromPizarra from './pizarra.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const pizarraState = createFeatureSelector<PizarraState>("pizarra");

export const pizarraEventos = createSelector(
	pizarraState,
	fromPizarra.selectAll
);

export const pizarraEventosReady = createSelector(
	pizarraState,
	state => state.ready
);

export const pizarraStatus = createSelector(
	pizarraState,
	state => state.status
);

export const pizarraLoading = createSelector(
	pizarraEventosReady,
	pizarraStatus,
	(ready, status) => ( !ready && !status || ( !ready && status && !status.qty ))
);

export const pizarraMaxEventQty = createSelector(
	pizarraState,
	state => state.maxEventQty
);